"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCents = exports.formatCents = void 0;
function formatCents(n) {
    if (n === undefined)
        return '0.00';
    n = Math.round(n);
    var dollars = Math.floor(n / 100);
    var cents = (n % 100).toString().padStart(2, '0');
    return dollars + "." + cents;
}
exports.formatCents = formatCents;
function parseCents(str) {
    var parts = str.split('.');
    var dollars = parseInt(parts[0], 10);
    var cents = 0;
    if (parts.length >= 2) {
        cents = parseInt(parts[1].substring(0, 2).padEnd(2, '0'), 10);
    }
    if (isNaN(dollars))
        dollars = 0;
    if (isNaN(cents))
        cents = 0;
    return Math.round(dollars * 100 + cents);
}
exports.parseCents = parseCents;
